import { useTranslation } from 'react-i18next';

interface ShortageFooterProps {
    onOpenWarehouse: () => void;
}

const ShortageFooter = ({ onOpenWarehouse }: ShortageFooterProps) => {
    const { t } = useTranslation(['Objects']);

    return (
        <div className="proposal-shortage__footer">
            <button
                type="button"
                className="proposal-shortage__link-btn"
                onClick={onOpenWarehouse}
            >
                <i className="bi bi-box-arrow-in-down" aria-hidden="true" />
                {t('proposalShortage.btnToWarehouse')}
            </button>
        </div>
    );
};

export default ShortageFooter;
